import { createContext, useContext } from 'react';

import { ControlProps } from '../../../../sections/blocks/SectionBlock/interfaces';

type TTimelineSongsContext = {
  songsOptions: UseSongsReturn;
  refetchSongs: Function;
  section: TimelineSection;
  sections: TimelineSection[];
  controlRef?: Nullable<ControlProps>;
};

export const TimelineSongsContext = createContext<TTimelineSongsContext>(undefined!);

export const useTimelineSongs = () => useContext(TimelineSongsContext);
